import React from "react";

import { wrap } from "./RydTestbedWrap";
import { ProjectMainOptions } from "../components/dialogs/ProjectMainOptions";
import { RydProject } from "../model/project";

export function ProjectMainOptionsTestbed() {

    const project = RydProject.createForNewProject('test');

    return wrap(<>
        {/* Add your testbed components here */}
        <h1>ProjectMainOptions Testbed</h1>
        <ProjectMainOptions
            project={project}
            toggleLibraryCollapse={() => {}}
            toggleInspectorCollapse={() => {}}
            toggleMixerCollapse={() => {}}
         />
    </>);
}